const KB = 1024
const MB = 1024 * 1024

export const DEFAULT_UPLOAD_SIZE = 10 * MB;

export const AI_ATTACHMENT_MB = 10;
export const AI_ATTACHMENT_SIZE = AI_ATTACHMENT_MB * MB;
export const PDF_PROPOSAL_MB = 30;
export const PDF_PROPOSAL_SIZE = PDF_PROPOSAL_MB * MB;
export const CUSTOM_FONT_SIZE = 5 * MB;
export const AVATAR_SIZE = 800 * KB;